import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { TenantFeature } from '@verify/models';
import { filter, map, take } from 'rxjs';
import { AuthService } from '../auth.service';

export const hasFeatureGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);
  const features = route.data['features'];

  let featuresRequired: TenantFeature[];
  if (!Array.isArray(features)) {
    featuresRequired = [features];
  } else {
    featuresRequired = features;
  }
  return authService.tenant$.pipe(
    filter((tenant) => !!tenant),
    take(1),
    map((tenant) => {
      for (const feature of featuresRequired) {
        if (!tenant?.features?.includes(feature)) {
          return router.parseUrl('error?code=403');
        }
      }
      return true;
    }),
  );
};
